import createStore from "@Stores/base-factories"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendReportFactory()
  .extendReportViewFactory('sweep-winner')
  .factory()

export {
  Provider as SweepWinnerReportProvider,
  useStore as useSweepWinnerReportStore,
}
